// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2PLB-","overflowing":"ReadFullNote_overflowing__3JvVz"};